import { type BlockQuoteFragmentFragment, graphql } from "@commerce-frontend/types";
import { cn } from "@commerce-frontend/ui/helpers/styles";
import type { HTMLAttributes } from "react";

graphql(/* GraphQL */ `
	fragment BlockQuoteFragment on BlockQuote {
		__typename
		id
		content
		name
		title
	}
`);

type Props = {
	data: BlockQuoteFragmentFragment;
} & HTMLAttributes<HTMLDivElement>;

export const BlockQuote = ({ className, data }: Props) => {
	const { content, name, title } = data;
	const source = [name, title].filter(Boolean).join(", ");

	return (
		<div className={cn(["prose max-w-full", className])}>
			<blockquote>
				<p>{content}</p>
				{source.length > 0 && <p>{source}</p>}
			</blockquote>
		</div>
	);
};
